export default Object.freeze({
  ES: 'es',
  EN: 'en',
});
